/**
 * Capitan scrolltop.js v1.0.0
 *
 * Copyright brandung GmbH & Co.KG
 * http://www.brandung.de/
 *
 *
 * Date: 2020-03-17
 * MIT License (MIT)
 */
import CapBodyScroll from '../../code/js/Capitan/es6/CapBodyScroll';
var _ = {
  defaults: {
    componentSelector: '.scrolltop',
    pluginOptions: {
      classes: {
        isVisible: 'is-visible'
      }
    }
  }
};
var o = _.defaults; // Bind all events

function bindEvents() {
  var scrollTop = document.querySelector(o.componentSelector); // When the user clicks on the button, scroll to the top of the document

  scrollTop.addEventListener('click', function (e) {
    e.preventDefault();
    CapBodyScroll(0);
  });
}
/**
 * initialize the component
 * @export function
 */


export function init() {
  bindEvents();
}